/**
 * monthPanel.jsx
 *
 * @Author: apple
 * @Date: 2017/10/25 19:28
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import Button from '../../button';

const quarters = [0, 1, 2, 3];
const months = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
];
/**
 * @ignore
 * */
class MonthPanel extends Component {
  static propTypes = {};

  static defaultProps = {};

  handleSelect = value => e => {
    e.stopPropagation();
    const { selectType, onValueChange, onPanelTypeChange, onPanelDateChange } = this.props;
    if (selectType === 'month') {
      onValueChange(value);
    } else {
      onPanelTypeChange('date');
    }
    onPanelDateChange(value);
  };

  render() {
    const { prefixCls, panelDate, value, disabledMonth, rangeType } = this.props;

    const isRange = Array.isArray(value);
    return (
      <tbody className={`${prefixCls}-body`}>
        {quarters.map((_, index) => (
          <tr key={index}>
            {months.slice(3 * index, 3 * (1 + index)).map((monthLabel, monthIndex) => {
              let selected = false;
              const month = monthIndex + 3 * index;
              const item = moment(panelDate).month(month);
              if (isRange && rangeType === 'start') {
                selected = value[0] && item.isSame(value[0], 'month');
              } else if (isRange && rangeType === 'end') {
                selected = value[1] && item.isSame(value[1], 'month');
              } else {
                selected = value && item.isSame(value, 'month');
              }
              const disabled = disabledMonth && disabledMonth(item);
              const classes = classNames(`${prefixCls}-month-item`, {
                [`${prefixCls}-month-item-selected`]: selected,
                [`${prefixCls}-month-item-disabled`]: disabled,
              });
              const cellClasses = classNames(`${prefixCls}-month-cell`);
              return (
                <td key={month} title={item.format('YYYY-MM')} className={cellClasses}>
                  <Button
                    className={classes}
                    onClick={this.handleSelect(item)}
                    disabled={disabled}
                    shape="none">
                    {monthLabel}
                  </Button>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default MonthPanel;



// WEBPACK FOOTER //
// ./src/datePicker/panel/MonthPanel.jsx